export enum AdminNotificationType {
  InAppNotification = 1,
  EmailNotification = 2,
  Both = 3,
}
